/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOrderingProfileRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetOrderingProfileResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getOrderingProfile = (request: GetOrderingProfileRequest, options?: CashRequestOptions) => post<GetOrderingProfileRequest, GetOrderingProfileResponse>("/2.0/cash/get-ordering-profile", request, {...options, rejectOnError: true })